import { connect } from 'react-redux';
import {
  getNutritionPlan,
  createMeal,
  getMeasures
} from 'features/nutrition/ducks/nutritionActions';
import Loader from 'features/Loader/Loader';
import React from 'react';
import { upperFirstLetter } from 'utils/strings';
import MealForm from './MealForm';

const queryString = require('query-string');

class CreateMeal extends React.Component {
  constructor(props) {
    super(props);
    this.planId = props.match.params.plan_id;

    const searchParams = queryString.parse(props.location.search);
    const type = searchParams.type === 'snack' ? 'snack' : 'meal';

    this.meal = {
      name: '',
      tip: '',
      type: type,
      ingredients_calories: 0,
      ingredients_carbs: 0,
      ingredients_fat: 0,
      ingredients_protein: 0,
      ingredients: []
    };
  }

  componentDidMount() {
    this.props.getNutritionPlan(this.planId, this.props.history);
  }

  render() {
    const {
      nutritionPlan,
      createMeal,
      history,
      getMeasures,
      measurementsUnits,
      loadingMeasurements
    } = this.props;
    const title = `Create ${upperFirstLetter(this.meal.type)}`;

    if (nutritionPlan && nutritionPlan.currentNutrationLoadingState) {
      return (<Loader />);
    }
    return (
      nutritionPlan && (
        <MealForm
          nutritionPlan={nutritionPlan}
          updateMeal={createMeal}
          initialMeal={this.meal}
          headerTitle={title}
          pageTitle={title}
          history={history}
          getMeasures={getMeasures}
          measurementsUnits={measurementsUnits}
          loadingMeasurements={loadingMeasurements}
        />
      )
    );
  }
}

function mapStateToProps(state) {
  return {
    nutritionPlan: state.nutritionReducer.currentNutritionPlan,
    measurementsUnits: state.nutritionReducer.food.measurementsUnits,
    loadingMeasurements: state.nutritionReducer.food.loadingMeasurements
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getNutritionPlan: (planId, history) =>
      dispatch(getNutritionPlan(planId, history)),
    createMeal: (plan, meal, history) =>
      dispatch(createMeal(plan, meal, history)),
    getMeasures: (query, weight, calories, measure, quantity_size) => dispatch(getMeasures(query, weight, calories, measure, quantity_size))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateMeal);
